(ns frontend.global-events.toast
  (:require
   [re-frame.core :as rf]
   ["react-hot-toast" :default toast :refer (Toaster)]
   [oops.core :as oops]))

(rf/reg-fx
 ::info
 (fn [label _opts]
   (toast label)))

(rf/reg-fx
 ::success
 (fn [label _opts]
   (oops/ocall toast "success" label)))

(rf/reg-fx
 ::error
 (fn [message-or-opts]
   (let [opts (if (string? message-or-opts)
                {:message message-or-opts}
                message-or-opts)
         message (:message opts)]
     (oops/ocall toast "error" message))))

(rf/reg-event-fx
 ::success
 [rf/trim-v]
 (fn [_ [label]]
   {::success label}))
